import { supabase } from "@/integrations/supabase/client";
import type { TenantStats } from "@/types/superAdmin";
// On utilise l'implémentation commune : la copie locale qui vivait ici avait
// dérivé (contrat `{ data?, authExpired? }` sans champ `error`, 403 traité comme
// une session expirée), ce qui rendait tout échec indétectable côté appelant.
import { invokeWithRetry } from "./common/invokeWithRetry";

const FEATURE_FLAGS = {
  GET_TENANT_STATS: true,
};

/**
 * Get all tenant stats with app assignments
 */
export async function getTenantStats(): Promise<TenantStats[]> {
  if (!FEATURE_FLAGS.GET_TENANT_STATS) {
    console.log('[getTenantStats] Using fallback direct query');
    
    // Fallback to direct query (without gyms JOIN that causes PGRST200)
    const { data, error } = await supabase
      .from('tenant_stats_cache')
      .select(`
        *,
        app_gym_assignments(app_name)
      `)
      .order('created_at', { ascending: false });

    if (error) throw error;

    return (data || []).map((tenant: any) => ({
      ...tenant,
      app_name: tenant.app_gym_assignments?.[0]?.app_name || null,
    })) as TenantStats[];
  }

  console.log('[getTenantStats] Using edge function');
  
  const result = await invokeWithRetry<{ success?: boolean; data?: TenantStats[]; error?: string }>(
    'get-tenant-stats',
    {}
  );

  // Session expirée : la déconnexion est déjà lancée, inutile de faire remonter
  // une erreur à l'écran, l'utilisateur part vers /login.
  if (result.authExpired) return [];

  // Tout le reste (403 « super admin requis », 500, erreur métier en 200) doit
  // remonter : la page Tenants s'appuie sur react-query pour afficher l'échec.
  if (result.error) {
    throw new Error(result.error.message || 'Failed to fetch tenant stats');
  }

  if (!result.data?.success || !result.data?.data) {
    throw new Error(result.data?.error || 'Failed to fetch tenant stats');
  }

  return result.data.data as TenantStats[];
}
